export const APP_VERSION = 'v1.0.0'
export const BUILD_DATE = '05/03/2026'

export function getVersionInfo() {
  return {
    version: APP_VERSION,
    buildDate: BUILD_DATE,
    fullVersion: `${APP_VERSION} | Build: ${BUILD_DATE}`
  }
}
